import { render, staticRenderFns } from "./TextAreaInput.vue?vue&type=template&id=50f116b9&scoped=true&"
import script from "./TextAreaInput.vue?vue&type=script&lang=js&"
export * from "./TextAreaInput.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaInput.vue?vue&type=style&index=0&id=50f116b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f116b9",
  null
  
)

export default component.exports